import type { AppProps } from 'next/app'
import { appWithTranslation } from "next-i18next";

import { ErrorBoundary } from "common/components/ErrorBoundary";
import { PostHogProvider } from "common/providers/PostHogProvider";
import { SWRGlobalConfig } from "common/providers/SWRGlobalConfig";
import { IubendaProvider } from "common/providers/IubendaProvider";

import "common/styles/globals.scss";

function App({ Component, pageProps }: AppProps) {
  return (
    <PostHogProvider>
      <IubendaProvider>
        <ErrorBoundary>
          <SWRGlobalConfig>
            <Component {...pageProps} />
          </SWRGlobalConfig>
        </ErrorBoundary>
      </IubendaProvider>
    </PostHogProvider>
  );
}

export default appWithTranslation(App);
